import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { ESummaryStatus } from '../../enums';
import { summaryKeys } from './summary.keys';
import { getSummaryList, createSummary, getSummaryContent, updateSummaryContent, deleteSummary, getSummaryState, updateSummaryState, getSummaryPromptSettings, updateSummaryPromptSettings, replaySummary, cancelReplaySummary, resetSummaryPrompt, resetSummaryPromptSettings } from './summary.api';
export const useSummaryListQuery = () => {
    return useQuery({
        queryKey: summaryKeys.list(),
        queryFn: getSummaryList,
        staleTime: 0,
        refetchInterval: (query) => {
            const data = query.state.data;
            const hasReplaying = data?.some((s) => s.status === ESummaryStatus.Replaying);
            return hasReplaying ? 5000 : false;
        }
    });
};
export const useSummaryContentQuery = (id) => {
    return useQuery({
        queryKey: summaryKeys.content(id),
        queryFn: () => getSummaryContent(id),
        refetchInterval: () => 5000,
        staleTime: 0
    });
};
export const useSummaryStateQuery = (id) => {
    return useQuery({
        queryKey: summaryKeys.state(id),
        queryFn: () => getSummaryState(id),
        refetchInterval: () => 5000,
        staleTime: 0
    });
};
export const useSummaryPromptSettingsQuery = (id) => {
    return useQuery({
        queryKey: summaryKeys.prompt(id),
        queryFn: () => getSummaryPromptSettings(id),
        staleTime: 0
    });
};
export const useCreateSummaryMutation = () => {
    return useMutation({
        mutationFn: createSummary,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useUpdateSummaryContentMutation = () => {
    return useMutation({
        mutationFn: ({ id, data }) => updateSummaryContent(id, data),
        onSuccess: (_result, { id }) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.content(id) }).then();
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useUpdateSummaryStateMutation = () => {
    return useMutation({
        mutationFn: ({ id, data }) => updateSummaryState(id, data),
        onSuccess: (_result, { id }) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.state(id) }).then();
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useUpdateSummaryPromptSettingsMutation = () => {
    return useMutation({
        mutationFn: ({ id, data }) => updateSummaryPromptSettings(id, data),
        onSuccess: (_result, { id }) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.prompt(id) }).then();
        }
    });
};
export const useDeleteSummaryMutation = () => {
    return useMutation({
        mutationFn: deleteSummary,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useReplaySummaryMutation = () => {
    return useMutation({
        mutationFn: replaySummary,
        onSuccess: (_result, id) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.state(id) }).then();
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useCancelReplaySummaryMutation = () => {
    return useMutation({
        mutationFn: cancelReplaySummary,
        onSuccess: (_result, id) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.state(id) }).then();
            queryClient.invalidateQueries({ queryKey: summaryKeys.list() }).then();
        }
    });
};
export const useResetSummaryPromptMutation = () => {
    return useMutation({
        mutationFn: resetSummaryPrompt,
        onSuccess: (_result, id) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.prompt(id) }).then();
        }
    });
};
export const useResetSummaryPromptSettingsMutation = () => {
    return useMutation({
        mutationFn: resetSummaryPromptSettings,
        onSuccess: (_result, id) => {
            queryClient.invalidateQueries({ queryKey: summaryKeys.prompt(id) }).then();
        }
    });
};
//# sourceMappingURL=summary.query.js.map